import { getTvObject } from '@costar-ui/cosmos';

var tvObject = getTvObject({
  base: ['w-full', 'min-w-80', 'rounded-sm', 'border', 'border-neutral/10 bg-base', 'bg-clip-padding', 'text-left', 'align-middle', 'text-on-base', 'shadow-elevation-35',
  // 'backdrop-blur-2xl',
  // 'backdrop-saturate-200',
  'forced-colors:bg-[Canvas]', 'print:w-full', 'print:max-w-full', 'print:overflow-visible', 'print:border-none', 'print:backdrop-saturate-0', 'print:bg-clip-content', 'print:shadow-none'
  // 'print:backdrop-blur-none'
  ],
  variants: {
    size: {
      fit: 'max-w-fit',
      sm: 'max-w-screen-sm',
      std: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      xxl: 'max-w-screen-2xl',
      fixed: 'max-h-fit min-h-fit min-w-fit max-w-fit',
      fill: 'mx-auto'
    },
    fullHeight: {
      "true": ['h-full', 'print:max-h-max']
    },
    asBlock: {
      "true": '',
      "false": 'flex max-h-full overflow-hidden'
    }
    // Animation is currently not defined in Cosmos 2.0
    //isEntering: {
    // true: ['duration-200', 'ease-out', 'animate-in', 'zoom-in-105']
    //},
    // isExiting: {
    //   true: ['duration-200', 'ease-in', 'animate-out', 'zoom-out-95']
    // }
  }
});
var baseModal = tvObject;

export { baseModal as default };
//# sourceMappingURL=base-modal.esm.js.map
